import { BrandingTheme } from '@torticity/types'

import { Theme } from './theme'

const config: Theme = {
  key: BrandingTheme.VIOLET,
  label: 'Violet',
  tokens: {
    'primary-button': [
      'tw-bg-violet-600',
      'hover:tw-bg-violet-900',
      'tw-text-white',
      'tw-py-4',
      'tw-px-6',
      'tw-rounded-full',
      'tw-font-bold',
      'tw-text-md',
      'tw-cursor-pointer',
      'disabled:tw-opacity-50',
      'disabled:tw-cursor-not-allowed',
    ],
    'secondary-button': [
      'tw-border-violet-200',
      'tw-bg-violet-100',
      'tw-text-violet-950',
      'hover:tw-bg-violet-300',
      'active:tw-bg-violet-400',
      'tw-cursor-pointer',
    ],
    'tertiary-button': [
      'tw-bg-white',
      'tw-border-2',
      'tw-border-violet-600',
      'tw-text-violet-900',
      'hover:tw-bg-violet-50',
      'active:tw-bg-violet-100',
      'tw-rounded-full',
      'tw-font-semibold',
      'tw-text-md',
      'tw-py-2',
      'tw-px-6',
      'tw-cursor-pointer',
    ],

    'primary-text': ['tw-text-violet-700'],
    'header-nav': ['!tw-bg-violet-900'],
    'header-active-item': [
      'tw-font-semibold',
      'tw-text-violet-800',
      'tw-bg-white',
      'tw-bg-opacity-80',
    ],
    'loading-spinner': ['tw-fill-violet-600'],
    'primary-icon': ['tw-fill-violet-500', 'tw-text-violet-500'],
    'secondary-icon': [
      'tw-text-violet-800',
      'tw-bg-violet-100',
      'tw-flex',
      'tw-flex-shrink-0',
      'tw-content-center',
      'tw-items-center',
      'tw-justify-center',
      'tw-rounded-full',
    ],
    'tertiary-icon': ['tw-fill-violet-800', 'tw-text-violet-700'],
    'auth-footer': ['tw-text-white', '!tw-bg-violet-800'],
    'secondary-text': ['tw-text-violet-500'],
    'linear-gradient': ['tw-to-violet-500', 'tw-from-violet-900'],
    'light-linear-gradient': ['tw-bg-violet-500'],
    'dark-linear-gradient': ['tw-bg-violet-900'],
    'tracker-dots': ['tw-border-violet-500', 'tw-bg-violet-50'],
    'active-tracker-dot': ['tw-bg-violet-800', 'tw-rounded-full'],
    'action-flow': ['tw-bg-violet-600'],
    'action-flow-button': ['tw-bg-violet-600', 'hover:tw-bg-violet-900'],
    'mobile-tracker-line': ['tw-bg-violet-500'],
    'bottom-nav-active-bar': ['tw-bg-violet-700'],
    'dark-background': ['tw-bg-violet-800'],
    'light-background': ['tw-bg-violet-100'],
    'primary-border': ['tw-border-violet-600'],
    'dark-border': ['tw-border-violet-800'],
    'hover-background': ['hover:tw-bg-violet-100'],
    'hover-border': ['hover:tw-border-violet-600'],
  },
}

export default config
